import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DrillsService, UpdateDrillResponse } from '@drills/infra';
import { toDrillViewModel } from '../../../mappers/drill.view-model.mapper';
import { UpdateDrillCommandPayload } from './update-drill.command-payload';
import { UpdateDrillCommandResult } from './update-drill.command-result';

export class UpdateDrillCommandHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  execute(payload: UpdateDrillCommandPayload): Observable<UpdateDrillCommandResult> {
    return this.drillsService.update(payload.drillId, payload.changes).pipe(
      map((dto: UpdateDrillResponse) => ({
        drill: toDrillViewModel(dto)
      }))
    );
  }
}
